<template>
  <a-card :bordered="false">
      <a-row :gutter="24">
        <a-col :span="24">
          <!-- 条件搜索 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="48">
                <a-col :md="8" :sm="24">
                  <a-form-item label="登录地址">
                    <a-input
                      v-model:value="queryParam.ipaddr"
                      placeholder="请输入登录地址"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="使用状态">
                    <a-select
                      placeholder="请选择状态"
                      v-model:value="queryParam.status"
                      style="width: 100%"
                      allow-clear
                      class="no-border-radius-select"
                    >
                      <a-select-option
                        v-for="(d, index) in dict.type['sys_common_status']"
                        :key="index"
                        :value="d.value"
                        >{{ d.label }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <!-- 默认状态下，按钮在第一行 -->
                <a-col v-if="!advanced" :md="8" :sm="24">
                  <span
                    class="table-page-search-submitButtons"
                    :style="submitButtonStyle"
                  >
                    <a-button type="primary" @click="handleQuery" class="search-button"
                      >查询</a-button
                    >
                    <a-button style="margin-left: 8px" @click="resetQuery" class="no-border-button"
                      >重置</a-button
                    >
                    <a-button style="margin-left: 8px" @click="toggleAdvanced" class="toggle-button">
                      {{ advanced ? '收起' : '展开' }}
                      <UpOutlined v-if="advanced" />
                      <DownOutlined v-else />
                    </a-button>
                  </span>
                </a-col>
                <template v-if="advanced">
                  <a-col :md="8" :sm="24">
                    <a-form-item label="登录名称">
                      <a-input
                        v-model:value="queryParam.loginName"
                        style="width: 100%"
                        allow-clear
                        class="no-border-radius-input"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24">
                    <a-form-item label="登陆时间">
                      <a-range-picker
                        style="width: 100%"
                        v-model:value="dateRange"
                        valueFormat="YYYY-MM-DD"
                        format="YYYY-MM-DD"
                        allow-clear
                        class="no-border-radius-picker"
                      />
                    </a-form-item>
                  </a-col>
                  <!-- 展开后，按钮在第二行左对齐 -->
                  <a-col :md="8" :sm="24">
                    <span
                      class="table-page-search-submitButtons"
                      style="text-align: left; display: block;"
                    >
                      <a-button type="primary" @click="handleQuery" class="search-button"
                        >查询</a-button
                      >
                      <a-button style="margin-left: 8px" @click="resetQuery" class="no-border-button"
                        >重置</a-button
                      >
                      <a-button style="margin-left: 8px" @click="toggleAdvanced" class="toggle-button">
                        {{ advanced ? '收起' : '展开' }}
                        <UpOutlined v-if="advanced" />
                        <DownOutlined v-else />
                      </a-button>
                    </span>
                  </a-col>
                </template>
              </a-row>
            </a-form>
          </div>
          <!-- 操作 -->
          <div class="table-operations">
            <a-button
              type="text"
              shape="circle"
              @click="getList"
              class="refresh-icon-button"
            >
              <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
            </a-button>
            <a-button
              :disabled="single"
              @click="handleUnlock"
              v-hasPermi="['monitor:logininfor:unlock']"
              class="no-border-button unlock-button"
            >
              <UnlockOutlined />解锁
            </a-button>
            <a-button
              :disabled="multiple"
              @click="handleDelete"
              v-hasPermi="['monitor:logininfor:remove']"
              class="no-border-button delete-button"
            >
              <DeleteOutlined />删除
            </a-button>
            <a-button
              @click="handleClean"
              v-hasPermi="['monitor:logininfor:remove']"
              class="no-border-button clean-export-button"
            >
              <DeleteOutlined />清空
            </a-button>
            <a-button
              @click="handleExport"
              v-hasPermi="['system:logininfor:export']"
              class="no-border-button clean-export-button"
            >
              <UploadOutlined />导出
            </a-button>
            <!-- <table-setting
              :style="{ float: 'right' }"
              v-model:table-size="tableSize"
              v-model:value="columns"
              :refresh-loading="loading"
              @refresh="getList"
            /> -->
          </div>
          <!-- 数据展示 -->
          <div style="margin-top: 20px">
            <a-table
              :loading="loading"
              :size="tableSize"
              rowKey="infoId"
              :columns="columns"
              :data-source="list"
              :row-selection="{
                selectedRowKeys: selectedRowKeys,
                onChange: onSelectChange,
              }"
              :pagination="false"
              @change="handleTableChange"
              :bordered="tableBordered"
              :scroll="{ x: 'max-content' }"
              class="optimized-table"
            >
              <template v-slot:status="text, record">
                <span>
                  <dict-tag
                    :options="dict.type['sys_common_status']"
                    :value="record.status"
                  />
                </span>
              </template>
            </a-table>
          </div>
          <!-- 分页 -->
          <div class="pagination-wrapper">
            <div class="pagination-left">
              <span class="pagination-info">
                显示第 {{ (queryParam.pageNum - 1) * queryParam.pageSize + 1 }} 到第 {{ Math.min(queryParam.pageNum * queryParam.pageSize, total) }} 条数据/共 {{ total }} 条
              </span>
              <a-select
                v-model:value="queryParam.pageSize"
                style="width: 100px; margin-left: 8px"
                @change="onShowSizeChange(queryParam.pageNum, queryParam.pageSize)"
                class="no-border-radius-select"
              >
                <a-select-option :value="10">10条/页</a-select-option>
                <a-select-option :value="20">20条/页</a-select-option>
                <a-select-option :value="50">50条/页</a-select-option>
                <a-select-option :value="100">100条/页</a-select-option>
              </a-select>
            </div>
            <div class="pagination-right">
              <a-pagination
                :current="queryParam.pageNum"
                :total="total"
                :page-size="queryParam.pageSize"
                :show-total="false"
                @change="changeSize"
              />
              <span class="pagination-jump">
                到第
                <a-input-number
                  v-model:value="jumpPage"
                  :min="1"
                  :max="Math.ceil(total / queryParam.pageSize)"
                  style="width: 60px; margin: 0 4px"
                  @pressEnter="handleJumpPage"
                  class="no-border-radius-input-number"
                />
                页
              </span>
            </div>
          </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { SearchOutlined, RedoOutlined, UpOutlined, DownOutlined, UnlockOutlined, DeleteOutlined, UploadOutlined } from '@ant-design/icons-vue'
import {
  list,
  delLogininfor,
  cleanLogininfor,
  unlockLogininfor,
} from '@/api/monitor/logininfor'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Logininfor',
  components: {
    SearchOutlined,
    RedoOutlined,
    UpOutlined,
    DownOutlined,
    UnlockOutlined,
    DeleteOutlined,
    UploadOutlined,
  },
  mixins: [tableMixin],
  dicts: ['sys_common_status'],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      loading: false,
      // 非单个禁用
      single: true,
      // 选择用户名
      selectName: '',
      // 非多个禁用
      multiple: true,
      ids: [],
      total: 0,
      // 日期范围
      dateRange: [],
      // 跳转页码
      jumpPage: 1,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        ipaddr: null,
        userName: undefined,
        status: undefined,
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
          width: 80,
          customRender: ({ index }) => {
            const { pageNum, pageSize } = this.queryParam
            return (pageNum - 1) * pageSize + index + 1
          }
        },
        {
          title: '访问编号',
          dataIndex: 'infoId',
          align: 'center',
        },
        {
          title: '用户名称',
          dataIndex: 'userName',
          align: 'center',
        },
        {
          title: '登录地址',
          dataIndex: 'ipaddr',
          align: 'center',
        },
        {
          title: '登录地点',
          dataIndex: 'loginLocation',
          align: 'center',
        },
        {
          title: '浏览器',
          dataIndex: 'browser',
          align: 'center',
        },
        {
          title: '操作系统',
          dataIndex: 'os',
          align: 'center',
        },
        {
          title: '登录状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
        {
          title: '操作信息',
          dataIndex: 'msg',
          align: 'center',
        },
        {
          title: '登录时间',
          dataIndex: 'loginTime',
          align: 'center',
          sorter: true,
        },
      ],
    }
  },
  created() {
    this.getList()
  },
  computed: {
    submitButtonStyle() {
      return this.advanced ? { float: 'right', overflow: 'hidden' } : {}
    },
  },
  watch: {},
  methods: {
    handleTableChange(pagination, filters, sorter) {
      const sort = this.tableSorter(sorter)
      this.queryParam.orderByColumn = sort.orderByColumn
      this.queryParam.isAsc = sort.isAsc
      this.getList()
    },
    /** 查询登录日志列表 */
    getList() {
      this.loading = true
      list(this.addDateRange(this.queryParam, this.dateRange)).then(
        (response) => {
          if (response.success) {
            this.list = response.data.records
            this.total = response.data.total
            this.jumpPage = this.queryParam.pageNum
            this.loading = false
          }
        }
      )
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        ipaddr: null,
        userName: undefined,
        status: undefined,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = 1
      this.jumpPage = 1
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.jumpPage = current
      this.getList()
    },
    handleJumpPage() {
      if (this.jumpPage && this.jumpPage >= 1) {
        const maxPage = Math.ceil(this.total / this.queryParam.pageSize)
        if (this.jumpPage > maxPage) {
          this.jumpPage = maxPage
        }
        this.queryParam.pageNum = this.jumpPage
        this.getList()
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.infoId)
      this.multiple = !selectedRowKeys.length
      this.single = selectedRowKeys.length !== 1
      if (this.single) {
        this.selectName = this.selectedRows.map((item) => item.userName)
      }
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const infoIds = row.infoId || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中访问编号为' + infoIds + '的数据',
        onOk() {
          return delLogininfor(infoIds).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 清空按钮操作 */
    handleClean() {
      var that = this
      this.$confirm({
        title: '是否确认清空?',
        content: '此操作将会清空所有登录日志数据项',
        onOk() {
          return cleanLogininfor().then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('清空成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 解锁按钮操作 */
    handleUnlock() {
      var that = this
      const username = this.selectName
      this.$confirm({
        title: '是否确认解锁用户:' + username + '?',
        onOk() {
          return unlockLogininfor(username).then(() => {
            that.onSelectChange([], [])
            this.selectName = ''
            that.getList()
            that.$message.success('解锁成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'monitor/logininfor/export',
            {
              ...that.queryParam,
            },
            `logininfor_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 80px;
  min-width: 80px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 80px;
  text-align: right;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 - 优先级高于 no-border-radius-input */
/* 普通输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  background: #FFFFFF !important;
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框外层样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  background: #FFFFFF !important;
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
/* 使用更具体的选择器确保覆盖所有情况 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.ant-form-item .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input-content .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper input.ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input[type="text"]) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  width: 100% !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  background: #FFFFFF !important;
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  background: #FFFFFF !important;
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.table-page-search-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

/* 移除搜索栏输入框、下拉选择框、日期选择框聚焦时的高亮效果 */
/* 输入框聚焦样式 - 内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-focused) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 带前缀/后缀的输入框聚焦样式 - 外部容器保持边框，内部input隐藏边框，聚焦时不显示高亮 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused) {
  border: 1px solid #C7C7C7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 聚焦时，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 下拉选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector:focus),
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-focused .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector:focus),
.table-page-search-wrapper :deep(.ant-select-focused .ant-select-selector) {
  border: 1px solid #C7C7C7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker:focus),
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker-focused),
.table-page-search-wrapper :deep(.ant-picker:focus),
.table-page-search-wrapper :deep(.ant-picker-focused) {
  border: 1px solid #C7C7C7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 搜索区域数字输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input-number.ant-input-number),
.table-page-search-wrapper :deep(.no-border-radius-input-number) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background-color: #F3F3F3 !important;
  color: #101010 !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
  background-color: #F3F3F3 !important;
  color: #101010 !important;
}

/* 解锁按钮样式 - 参照 projectUser 页面修改状态按钮 */
.unlock-button {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

.unlock-button:hover,
.unlock-button:focus {
  color: #333333 !important;
}

.unlock-button:disabled {
  color: rgba(0, 0, 0, 0.25) !important;
}

/* 删除按钮样式 - 参照 projectUser 页面修改状态按钮 */
.delete-button {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

.delete-button:hover,
.delete-button:focus {
  color: #333333 !important;
}

.delete-button:disabled {
  color: rgba(0, 0, 0, 0.25) !important;
}

/* 清空和导出按钮背景颜色 */
.clean-export-button {
  background: #F3F3F3 !important;
  color: #333 !important;
}

.clean-export-button :deep(.anticon) {
  color: #333 !important;
}

.clean-export-button:hover,
.clean-export-button:focus {
  background: #F3F3F3 !important;
  color: #333 !important;
}

.clean-export-button:hover :deep(.anticon),
.clean-export-button:focus :deep(.anticon) {
  color: #333 !important;
}

/* 展开/收起按钮文字和图标颜色 - 去掉背景 */
.toggle-button {
  background: transparent !important;
  border: none !important;
  color: #165DFF !important;
  box-shadow: none !important;
}

.toggle-button :deep(.anticon) {
  color: #165DFF !important;
}

.toggle-button:hover,
.toggle-button:focus {
  background: transparent !important;
  border: none !important;
  color: #165DFF !important;
  box-shadow: none !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165DFF !important;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #FFFFFF !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165DFF !important;
  border-color: #165DFF !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #FFFFFF !important;
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap; /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap; /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px; /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #FFFFFF !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

/* Confirm 弹窗按钮样式 */
:deep(.ant-modal-confirm .ant-btn) {
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-default) {
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-primary) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
  color: #FFFFFF !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:hover:not(:disabled)) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:focus:not(:disabled)) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:active:not(:disabled)) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}
</style>

<style>
/* Confirm 弹窗按钮样式 - 全局样式确保生效（confirm弹窗是动态创建的） */
.ant-modal-confirm .ant-modal-confirm-btns .ant-btn {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-default {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
  color: #FFFFFF !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:focus:not(:disabled) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:active:not(:disabled) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}
</style>
